import React from "react";
import DataTable from "../../components/data-table";
import ValidationReg from "../../common/ValidationReg";
import * as bankService from "../../services/kyc/kyc-service";
import * as kyc from "../../services/kyc/kyc-service";
import { v4 as uuidv4 } from "uuid";
import Auth from "../../utils/auth";
import * as xmlService from "../../services/xml/xml-service";
import { CSVLink } from "react-csv";
import { Authorize } from "../../components/authorize";
import { validateEntitlement } from "../../common/validate-entitlement";
import { downloadFile } from "../../common/download-file";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import {
  FUNCTIONALITY,
  ENTITLEMENTS,
  validFileExtensions,
  defaultListItem,
} from "../../common/const";
import * as Loader from "../../common/common";
import utility from "../../components/modal";
import * as addressService from "../../services/kyc/address-service";
import * as validate from "../../common/validate-file-extension";
import TextBox from "../../components/form-controls/textbox";
import { messages } from "../../common/messages";
import DropDown from "../../components/form-controls/dropdown";
import XmlDownload from "../../components/xml-download/xml-download";
import * as validateFileExt from "../../common/validate-file-extension";
import config from "../../common/config";
import { withOutletPropsAndNavigation } from "../../common/hocs";
let EditOrAdd = "New Bank";
let buttonName = "";

class BankList extends Authorize {
  constructor(props) {
    super(props);
    this.buttonClick = this.buttonClick.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.FileUpload = this.FileUpload.bind(this);
    this.onClear = this.onClear.bind(this);
    this.generateBankXml = this.generateBankXml.bind(this);
    this.getBanksForCSV = this.getBanksForCSV.bind(this);
    this.handlePrevNext = this.handlePrevNext.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.setInitialData = this.setInitialData.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.downloadPdfList = this.downloadPdfList.bind(this);
    this.state = {
      clientId: this.props.clientId,
      userType: this.props.clientType,
      bank: {
        bankId: "",
        bankName: "",
        accountNumber: "",
        ifscCode: "",
        accountType: "",
        branch: "",
        clientId: "",
      },
      file: {},
      validationErrors: {},
      msg: "",
      fileUploadError: "",
      fileUploadMsg: "",
      deleteMsg: "",
      error: "",
      message: "",
      showModel: false,

      headers: [
        {
          title: "Bank Name",
          accessor: "bankName",
          index: 0,
          dataType: "string",
        },
        {
          title: "Account Number",
          accessor: "accountNumber",
          index: 1,
          dataType: "string",
        },
        {
          title: "IFSC Code",
          accessor: "ifscCode",
          index: 2,
          dataType: "string",
        },
        {
          title: "",
          accessor: "",
          index: 3,
          cell: (row) => {
            return (
              <div className="btn-group float-right ">
                {validateEntitlement(
                  FUNCTIONALITY.bankDetails,
                  ENTITLEMENTS.edit
                ) ? (
                  <button
                    title="Edit"
                    type="button"
                    onClick={this.edit.bind(this, row.bankId)}
                    className="btn btn-sm btn-primary fas fa-edit rounded-0"
                  ></button>
                ) : null}
                {validateEntitlement(
                  FUNCTIONALITY.bankDetails,
                  ENTITLEMENTS.delete
                ) ? (
                  <button
                    title="Delete"
                    onClick={this.delete.bind(this, row.bankId)}
                    type="button"
                    className="btn btn-sm btn-danger fas fa-trash-alt rounded-0"
                  ></button>
                ) : null}
                <button
                  title="Download as PDF"
                  onClick={this.downloadPdf.bind(
                    this,
                    this.state.clientId,
                    row.bankId
                  )}
                  type="button"
                  className="btn btn-sm btn-warning  rounded-0"
                >
                  <span className="fa fa-download"></span>
                </button>
              </div>
            );
          },
        },
      ],
      data: [],
      accountTypes: [],
      csvData: [],
      csvHeaders: [],
      regenerateMsg: "",
      isDisabled: false,
    };
  }

  kycStatus = "";

  edit(id, e) {
    EditOrAdd = "Edit Bank";
    buttonName = "Update";

    let editData = this.state.data.filter((ele) => {
      return ele.bankId === id;
    });
    if (this.state.showModel === false) {
      this.setState({
        bank: editData[0],
        file: editData[0].file,
        showModel: !this.state.showModel,
        msg: "",
        deleteMsg: "",
      });
    } else {
      this.setState({
        bank: editData[0],
        file: editData[0].file,
        msg: "",
        deleteMsg: "",
      });
    }
  }

  async downloadPdf(clientId, bankId) {
    let data = { clientId: clientId, bankId: bankId };
    let { response, err } = await commonDownloadPdfService.downloadBank(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "Bank_" + clientId + "_" + bankId);
    }
  }

  async downloadPdfList(clientId) {
    let data = { clientId: clientId };
    let { response, err } = await commonDownloadPdfService.downloadBankList(
      data
    );
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "BankList_" + clientId);
    }
  }

  downloadFile = async (name, id) => {
    downloadFile(this, name, id);
  };

  async delete(id, e) {
    if (this.state.isDisabled) return false;

    var that = this;
    var config = {
      message: messages.confirmDeleteBank,
      onYesClick: async function () {
        Loader.showLoader();
        let { response, err } = await bankService.deleteBanksDetails(id);
        if (err) {
          that.setState({
            ...that.state,
            loading: false,
          });
        } else if (response && response.data.err) {
          that.setState({
            ...that.state,
            loading: false,
          });
        } else {
          Loader.hideLoader();
          let dataAfterDelete = that.state.data.filter((ele) => {
            return ele.bankId !== id;
          });

          that.setState({
            data: dataAfterDelete,
            deleteMsg: messages.deleteMessage,
            msg: "",
          });
        }
      },
      onNoClick: null,
    };
    utility.showConfirm(config);
  }

  deleteFile(fileId, filename) {
    var that = this;
    var config = {
      message: messages.confirmDeleteFile,
      onYesClick: async function () {
        let objDelFile = {
          fileId: fileId,
          name: filename,
          userId: that.state.clientId,
        };

        Loader.showLoader();
        let { response, err } = await bankService.deleteFile(objDelFile);
        if (err) {
          that.setState({
            ...that.state,

            loading: false,
          });
        } else if (response && response.data.err) {
          that.setState({
            ...that.state,
            loading: false,
          });
        } else {
          Loader.hideLoader();
          that.setState({
            file: {},
            fileUploadMsg: "",
            fileUploadError: "",
          });

          addressService.deleteFile(objDelFile);
        }
      },
      onNoClick: null,
    };
    utility.showConfirm(config);
  }

  async FileUpload(e) {
    let validationErrors = Object.assign({}, this.state.validationErrors);

    let isValidFileExtension = validate.validateFileExtension(
      e.target.files[0].name
    );
    let fileCount = e.target.files.length;
    if (fileCount > 0) {
      let filesObj = {};
      Object.assign(filesObj, e.target.files);
      var filereader = new FileReader();
      const blob = filesObj[0].slice(0, 4);
      filereader.readAsArrayBuffer(blob);
      filereader.onloadend = async (evt) => {
        let isValidFileExtension = validateFileExt.validateFileExtensionMimeType(
          evt
        );
        if (isValidFileExtension) {
          validationErrors.fileError = "";
          let file = {};
          file.id = uuidv4();
          file.name = filesObj[0].name;

          this.setState({
            // file: file,
            validationErrors: validationErrors,
          });

          let formData = new FormData();

          formData.append("file", filesObj[0]);
          formData.append("filename", file.id + "_" + filesObj[0].name);
          formData.append("userId", this.state.clientId);
          formData.append("fileId", uuidv4());

          let { response, err } = await bankService.uploadFile(formData);

          if (err) {
            this.setState({
              fileUploadError:
                "File limit has exceeded, Please upload file size of maximum 2 MB",
            });
          } else if (response && response.data.err) {
            this.setState({
              fileUploadError: response.data.err,
            });
          } else {
            this.setState({
              fileUploadMsg: response.data.msg,
              fileUploadError: "",
              file: file,
            });
          }
        } else {
          validationErrors.fileError = messages.fileExtensionError;
          this.setState({
            validationErrors: validationErrors,
            file: {},
          });
        }
      };
    }

    document.getElementById("bankDoc").value = "";
  }

  buttonClick() {
    EditOrAdd = "New Bank";
    buttonName = "Save";

    this.setState({
      bank: {
        bankId: "",
        bankName: "",
        accountNumber: "",
        ifscCode: "",
        accountType: "",
        branch: "",
      },
      validationErrors: {},
      file: {},
      msg: "",
      deleteMsg: "",
      error: "",
      fileUploadMsg: "",
      showModel: !this.state.showModel,
    });
  }

  onChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "ifscCode" || name === "bankName" || name === "branch") {
      if (value.match(config.regex) || value === "") {
        this.setState({
          bank: {
            ...this.state.bank,
            [name]: value.toUpperCase(),
          },
        });
      }
    } else {
      this.setState({
        bank: {
          ...this.state.bank,
          [name]: value,
        },
      });
    }

    let validationErrors = Object.assign({}, this.state.validationErrors);

    if (name === "bankName") {
      if (value) {
        if (!ValidationReg.nameValid.test(value)) {
          validationErrors.bankNameError = "Please enter valid Bank Name";
        } else {
          validationErrors.bankNameError = "";
        }
      } else {
        validationErrors.bankNameError = "Please enter Bank Name";
      }
    } else if (name === "accountNumber") {
      if (value) {
        if (!ValidationReg.numberValid.test(value)) {
          validationErrors.accountNumberError =
            "Please enter valid Account Number";
        } else {
          validationErrors.accountNumberError = "";
        }
      } else {
        validationErrors.accountNumberError = "Please enter Account Number";
      }
    } else if (name === "accountType") {
      if (!value) {
        validationErrors.accountTypeError = "Please enter Account Type";
      } else {
        validationErrors.accountTypeError = "";
      }
    } else if (name === "ifscCode") {
      if (value) {
        if (!ValidationReg.IFSCCodeValid.test(value)) {
          validationErrors.ifscCodeError = "Please enter valid IFSC Code";
        } else {
          validationErrors.ifscCodeError = "";
        }
      } else {
        validationErrors.ifscCodeError = "Please enter IFSC Code";
      }
    } else if (name === "branch") {
      if (value) {
        if (!ValidationReg.nameValid.test(value)) {
          validationErrors.branchError = "Please enter valid Branch Name";
        } else {
          validationErrors.branchError = "";
        }
      } else {
        validationErrors.branchError = "Please enter Branch Name";
      }
    }
    this.setState({
      validationErrors: validationErrors,
    });
  }

  onClear() {
    this.setState({
      bank: {
        bankId: "",
        bankName: "",
        accountNumber: "",
        ifscCode: "",
        accountType: "",
        branch: "",
        clientId: "",
        validFile: "",
      },
      validationErrors: {},
      msg: "",
      deleteMsg: "",
      error: "",
      file: {},
    });
  }

  async onSubmit(id) {
    Loader.showLoader();
    let validationFlag = false;
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (this.state.bank.bankName) {
      if (!ValidationReg.nameValid.test(this.state.bank.bankName)) {
        validationErrors.bankNameError = "Please enter a valid Bank Name";
        validationFlag = true;
      } else {
        validationErrors.bankNameError = "";
      }
    } else {
      validationErrors.bankNameError = "Please enter Bank Name";
      validationFlag = true;
    }

    if (this.state.bank.accountNumber) {
      if (!ValidationReg.numberValid.test(this.state.bank.accountNumber)) {
        validationErrors.accountNumberError =
          "Please enter valid account number";
        validationFlag = true;
      } else {
        validationErrors.accountNumberError = "";
      }
    } else {
      validationErrors.accountNumberError = "Please enter Account Number";
      validationFlag = true;
    }

    if (!this.state.bank.accountType) {
      validationErrors.accountTypeError = "Please enter Account Type";
      validationFlag = true;
    } else {
      validationErrors.accountTypeError = "";
    }

    if (this.state.bank.ifscCode) {
      if (!ValidationReg.IFSCCodeValid.test(this.state.bank.ifscCode)) {
        validationErrors.ifscCodeError = "Please enter valid IFSC Code";

        validationFlag = true;
      } else {
        validationErrors.ifscCodeError = "";
      }
    } else {
      validationErrors.ifscCodeError = "Please enter IFSC Code";

      validationFlag = true;
    }

    if (this.state.bank.branch) {
      if (!ValidationReg.nameValid.test(this.state.bank.branch)) {
        validationErrors.branchError = "Please enter valid Branch";

        validationFlag = true;
      } else {
        validationErrors.branchError = "";
      }
    } else {
      validationErrors.branchError = "Please enter Branch";

      validationFlag = true;
    }

    if (!(this.state.file && this.state.file.name)) {
      validationErrors.fileError = "Please upload file";
      validationFlag = true;
    } else {
      validationErrors.fileError = "";
    }

    let arr = this.state.data.filter((ele) => {
      return ele.bankId !== id;
    });

    let bank = Object.assign({}, this.state.bank);
    if (!id) {
      bank.bankId = uuidv4();
    } else {
      bank.bankId = id;
    }
    bank.clientId = this.state.clientId;
    if (validationFlag === false) {
      let { response, err } = await bankService.saveBanksDetails(bank);
      Loader.hideLoader();
      if (err) {
        this.setState({
          error: err,
        });
      } else if (response.data && response.data.err) {
        this.setState({
          error: response.data.err,
        });
      } else {
        let fileObj = Object.assign({}, this.state.file);
        fileObj.userId = this.state.clientId;
        fileObj.fileType = "Bank - cancelled cheque";
        fileObj.fileTypeId = bank.bankId;

        bankService.saveUploadFile(fileObj);

        let bankObj = Object.assign({}, bank);
        bankObj.file = {
          id: fileObj.id,
          name: fileObj.name,
        };

        this.setState({
          bank: {
            bankId: "",
            bankName: "",
            accountNumber: "",
            ifscCode: "",
            accountType: "",
            branch: "",
          },
          data: [...arr, bankObj],
          msg: response.data.msg,
          file: {},
          fileUploadMsg: "",
          showModel: !this.state.showModel,
        });
      }
    } else {
      Loader.hideLoader();
      this.setState({
        validationErrors: validationErrors,
        msg: "",
      });
    }
  }
  setInitialData(context) {
    let accountTypes = [];
    if (!!context) {
      let actions = context.actions;
      accountTypes = actions.getMastersByGroup("AccountType");
    }

    this.setState({
      accountTypes: accountTypes,
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.context !== prevProps.context) {
      this.setInitialData(this.props.context);
    }
  }
  async componentDidMount() {
    Loader.showLoader();
    this.setInitialData(this.props && this.props.context);
    let clientId = this.state.clientId;
    let responses = await bankService.getAllActiveBanksDetails(clientId);
    Loader.hideLoader();
    let data =
      responses.response && responses.response.data
        ? responses.response.data
        : null;
    let arrFiltered = [];
    if (data) {
      if (data.length > 0) {
        arrFiltered = data.filter(function (x) {
          return x.isDeleted !== true;
        });
        this.setState({
          data: arrFiltered,
        });
      }
    } else {
    }

    let clientIdForStatus;
    if (Auth.get("userType") !== "InternalUser") {
      clientIdForStatus = Auth.get("userId");
    } else {
      clientIdForStatus = this.props.clientId;
    }
    Loader.showLoader();
    let { response, err } = await kyc.getKycStatus(clientIdForStatus);
    Loader.hideLoader();
    if (err) {
    } else {
      this.kycStatus = response.data.kycStatus;
      if (Auth.get("userType") !== "InternalUser") {
        if (
          !this.kycStatus ||
          this.kycStatus === "REOPENED" ||
          this.kycStatus === "DRAFT" ||
          this.kycStatus === "REJECTED"
        ) {
          this.setState({ isDisabled: false });
        } else {
          this.setState({ isDisabled: true });
        }
      }
    }
    if (
      validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create) &&
      this.kycStatus === "APPROVED"
    ) {
      this.getBanksForCSV();
    }

    this.setState({
      msg: "",
      deleteMsg: "",
    });
  }

  async generateBankXml() {
    Loader.showLoader();
    let data = {
      clientId: this.state.clientId,
      userType: this.state.userType,
    };
    let { response, err } = await xmlService.generateBankXml(data);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }

  async getBanksForCSV() {
    Loader.showLoader();
    let { response, err } = await bankService.getBanksForCSV(
      this.state.clientId
    );
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else if (response.data && response.data.length > 0) {
      let data = response.data;
      let headers = [];
      for (let i = 0; i < 1; i++) {
        for (let key in data[i]) {
          headers.push(key);
        }
      }
      this.setState({
        csvData: data,
        csvHeaders: headers,
      });
    }
  }

  getFileName() {
    let fileType = ".csv";
    let date = new Date(),
      dateformat = [
        date.getDate(),
        date.getMonth() + 1,
        date.getFullYear(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ].join("-");
    let fileName;
    fileName = "Banks_" + this.state.clientId + "_" + dateformat + fileType;
    return fileName;
  }

  handlePrevNext(v, e) {
    if (v && v === "prev") {
      if (this.state.userType !== Auth.get("userType")) {
        this.props.navigate(
          "/kycs/" +
          this.state.clientId +
          "/" +
          this.state.userType +
          "/contacts"
        );
      } else {
        this.props.navigate("/kyc/contacts");
      }
    } else if (v && v === "next") {
      if (this.state.userType !== Auth.get("userType")) {
        this.props.navigate(
          "/kycs/" +
          this.state.clientId +
          "/" +
          this.state.userType +
          "/addresses"
        );
      } else {
        this.props.navigate("/kyc/addresses");
      }
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let disable = this.state.isDisabled;
    let files = null;
    if (this.state.file && this.state.file.name) {
      files = (
        <tr>
          <td>Cancelled Cheque</td>
          <td>{this.state.file.name}</td>
          <td className="text-center">
            {!this.state.isDisabled ? (
              <span alt="Delete" className="">
                <a
                  onClick={this.deleteFile.bind(
                    this,
                    this.state.file.id,
                    this.state.file.name
                  )}
                >
                  <i className="text-danger  fa fa-trash"></i>
                </a>
              </span>
            ) : null}
          </td>
          <td className="text-center">
            <span alt="Download" className="">
              <a
                onClick={this.downloadFile.bind(
                  this,
                  this.state.file.name,
                  this.state.file.id
                )}
              >
                <i className="text-info  fa fa-download"></i>{" "}
              </a>
            </span>
          </td>
        </tr>
      );
    }
    return (
      <div className="container-fluid">
        <div className="row mt-1">
          <div className="col-sm-12 text-center">
            <p className="text-danger text-center font-weight-bold">
              You need to provide your bank details and upload a cancelled
              cheque before you submit the KYC for approval.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.deleteMsg && (
              <div className="alert alert-success">{this.state.deleteMsg}</div>
            )}

            {this.state.msg && (
              <div className="alert alert-success">{this.state.msg}</div>
            )}
            {this.state.regenerateMsg && (
              <div className="alert alert-success">
                {this.state.regenerateMsg}
              </div>
            )}
          </div>

          <div className="col-md-12">
            <span className="float-sm-right btn-group ">
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) &&
                this.kycStatus === "APPROVED" &&
                !this.state.showModel ? (
                <React.Fragment>
                  <button
                    className="btn btn-warning btn-xs"
                    onClick={this.generateBankXml}
                  >
                    Generate XML
                  </button>
                  <XmlDownload
                    type="bank"
                    obj={{
                      clientId:
                        Auth.get("userType") !== "InternalUser"
                          ? Auth.get("userId")
                          : this.props.clientId,
                      userType:
                        Auth.get("userType") !== "InternalUser"
                          ? Auth.get("userType")
                          : this.props.clientType,
                    }}
                  />
                </React.Fragment>
              ) : null}
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) &&
                this.kycStatus === "APPROVED" &&
                !this.state.showModel ? (
                this.state.csvHeaders &&
                  this.state.csvHeaders.length > 0 &&
                  this.state.csvData &&
                  this.state.csvData.length > 0 ? (
                  <button className="btn  btn-info btn-xs">
                    <CSVLink
                      style={{ color: "black" }}
                      headers={this.state.csvHeaders}
                      data={this.state.csvData}
                      filename={this.getFileName()}
                    >
                      <i className="fa fa-download text-black"></i> CSV
                    </CSVLink>
                  </button>
                ) : null
              ) : null}

              {!this.state.showModel ? (
                <button
                  className="btn  btn-info btn-xs"
                  title="Download PDF"
                  onClick={this.downloadPdfList.bind(this, this.state.clientId)}
                >
                  <i className=" fa fa-download text-black"></i> PDF
                </button>
              ) : null}
            </span>
            <button
              disabled={this.state.isDisabled && !this.state.showModel}
              className={
                this.state.showModel
                  ? "btn btn-sm btn-danger fixedCtaBtn"
                  : "btn btn-sm btn-success  fixedCtaBtn"
              }
              onClick={this.buttonClick}
            >
              {this.state.showModel ? "CLOSE" : "ADD"}{" "}
            </button>
          </div>
          <div
            style={
              this.state.showModel ? { display: "none" } : { display: "block" }
            }
            className="col-sm-12 divWidth"
          >
            <DataTable
              keyField="id"
              pagination={{
                enabled: true,
                pageLength: 15,
                type: "long",
              }}
              title="Banks"
              width="100%"
              headers={this.state.headers}
              data={this.state.data}
              noData="No records!"
            />

            <div className="row pt-2">
              <div className="col-sm-12 text-center">
                <div className="row pt-0 mt-2">
                  <div className="col-sm-12 text-center">
                    <p className="text-danger text-center font-weight-bold">
                      You need to provide your bank details and upload a
                      cancelled cheque before you submit the KYC for approval.
                    </p>
                  </div>
                </div>
                <a
                  className="fa fa-angle-double-left mr-3 text-muted arrow"
                  onClick={this.handlePrevNext.bind(this, "prev")}
                >
                  &nbsp;
                </a>
                <a
                  className="fa fa-angle-double-right text-black arrow"
                  onClick={this.handlePrevNext.bind(this, "next")}
                >
                  &nbsp;
                </a>
              </div>
            </div>
          </div>
          {this.state.showModel ? (
            <div className="col-sm-12">
              <form id="formClient">
                <h3 className="page-title">{EditOrAdd}</h3>
                <div className="row">
                  <div className="col-sm-4">
                    <DropDown
                      label="Account Type"
                      name="accountType"
                      required="true"
                      value={this.state.bank.accountType || ""}
                      error={this.state.validationErrors.accountTypeError}
                      onChange={this.onChange}
                      defaultItem={defaultListItem}
                      list={this.state.accountTypes}
                      valProp="name"
                      textProp="name"
                      disabled={this.state.isDisabled}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Bank Name"
                      required="true"
                      value={this.state.bank.bankName}
                      name="bankName"
                      error={this.state.validationErrors.bankNameError}
                      onChange={this.onChange}
                      disabled={this.state.isDisabled}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Account Number"
                      required="true"
                      value={this.state.bank.accountNumber}
                      name="accountNumber"
                      error={this.state.validationErrors.accountNumberError}
                      onChange={this.onChange}
                      maxLength="16"
                      disabled={this.state.isDisabled}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="IFSC Code"
                      required="true"
                      value={this.state.bank.ifscCode || ""}
                      name="ifscCode"
                      error={this.state.validationErrors.ifscCodeError}
                      onChange={this.onChange}
                      maxLength="11"
                      disabled={this.state.isDisabled}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Branch"
                      required="true"
                      value={this.state.bank.branch || ""}
                      name="branch"
                      error={this.state.validationErrors.branchError}
                      onChange={this.onChange}
                      disabled={this.state.isDisabled}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="col-form-label">
                        File Upload (Cancelled Cheque){" "}
                        <span className="mandatory">*</span>
                      </label>
                      <input
                        type="file"
                        id="bankDoc"
                        name="file"
                        style={{ color: "transparent" }}
                        onChange={this.FileUpload}
                        autoComplete="off"
                        disabled={this.state.isDisabled}
                      />
                      <div>
                        <span style={{ color: "#73818f" }}>
                          Supported File Formats:{" "}
                          {validFileExtensions.join(",")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="row">
                      <label className="">Uploaded Files : </label>
                      <table className="table table-striped table-bordered file-list">
                        <tbody>{files}</tbody>
                      </table>
                      <div className="col-sm-12">
                        {this.state.fileUploadMsg ? (
                          <div className="alert alert-success">
                            {this.state.fileUploadMsg}
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.fileUploadError ? (
                          <div className="alert alert-danger">
                            {this.state.fileUploadError}
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.validationErrors.fileError ? (
                          <div className="alert alert-danger">
                            {this.state.validationErrors.fileError}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-12">
                    <button
                      className="btn btn-info btn-md rounded-0"
                      type="button"
                      onClick={this.onSubmit.bind(this, this.state.bank.bankId)}
                      disabled={this.state.isDisabled}
                    >
                      {buttonName}
                    </button>
                    <span>&nbsp;</span>
                    <button
                      className="btn btn-default  btn-md rounded-0"
                      type="button"
                      onClick={this.onClear}
                      disabled={this.state.isDisabled}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </form>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

// HOC to inject outlet context props and navigation function
export default withOutletPropsAndNavigation(BankList);